import React from "react";

// Files Import
import CtaButton from "../Buttons/CtaButton/CtaButton";
import StyledMdText from "../../common/components/styledMdText/StyledMdText";
import StyledH2Heading from "../../common/components/styledH2Heading/StyledH2Heading";
import StyledH5Heading from "../../common/components/styledH5Heading/StyledH5Heading";
import { useNavigate } from 'react-router-dom';

const styles = {
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center bottom",
  backgroundImage: "url('/assets/our-mission-shadow.png')",
};

const AboutUs = ({ custom }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/collection');
  }
  return (
    <div style={styles} className="w-full flex justify-center">
      <div
        className={`w-[90%] sm:w-[85%] md:w-[80%] flex flex-col justify-center items-center py-[75px] ${
          custom ? "gap-14 md:gap-24" : "gap-24"
        }`}
      >
        {/* Heading */}
        <div className="space-y-10">
          <div className="flex flex-col justify-center items-center text-center space-y-1">
            {!custom && (
              <StyledH5Heading fontColor={"-mb-2"}>
                Golden Words
              </StyledH5Heading>
            )}

            {!custom ? (
              <StyledH2Heading fontColor={"textGradient"}>
                Our Mission
              </StyledH2Heading>
            ) : (
              <StyledH2Heading fontColor={"textGradient"}>
                About Us
              </StyledH2Heading>
            )}
            {!custom ? (
              <StyledMdText fontColor={"lg:w-[60%] xl:w-1/2"}>
                We created a small batch of different options to keep a low
                circulation of art for a stronger profit margin towards your
                initial investment. We could have made over 10,000 units, but
                why over-saturate the rarity of these beauties?
              </StyledMdText>
            ) : (
              <StyledMdText fontColor={"w-[80%] lg:w-3/5 xl:w-1/2 "}>
                Let’s learn everything about Golden Year project. How it was
                themed and ideate. What steps we took, and how these golden NFTs
                come to life. Also learn the purpose of this project.
              </StyledMdText>
            )}
          </div>
          <div className="w-full flex justify-center">
            {!custom && (
              <CtaButton fontColor={"w-full"} children={"Golden Collection"} onClick={handleClick}/>
            )}
          </div>
        </div>
        {/* NFT's */}
        <div className="flex gap-4 sm:gap-5 md:gap-10 2xl:gap-16">
          <div className="outside">
            <img
              src="/assets/our-mission-1.png"
              alt="NFT's"
              className="-mt-[118%] hidden lg:flex borderYellow "
              loading="lazy"
            />
          </div>
          <div>
            <img
              src="/assets/our-mission-2.png"
              alt="NFT's"
              className="-mt-[40%] min-w-[85px] borderYellow"
              loading="lazy"
            />
          </div>
          <div>
            <img
              className=" min-w-[85px] borderYellow"
              src="/assets/our-mission-3.png"
              alt="NFT's"
              loading="lazy"
            />
          </div>
          <div>
            <img
              className=" -mt-[40%] min-w-[85px] borderYellow"
              src="/assets/our-mission-4.png"
              alt="NFT's"
              loading="lazy"
            />
          </div>
          <div>
            <img
              className=" -mt-[118%] hidden lg:flex borderYellow"
              src="/assets/our-mission-5.png"
              alt="NFT's"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
